import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.fixed";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Block from '../block/Block';
import SkipLink from '../skip-link/SkipLink';
import Guttered from '../guttered/Guttered';
import useDevice from '../hooks/use-device';
import useBrand from '../hooks/use-brand';
import useWindowBounds from '../use-window-bounds/use-window-bounds';
import { getClasses } from '../../lib/style-utils/style-utils';
import WFMastheadContext from './support/context/WFMastheadContext';
import WellsFargoLogo from './support/logos/wells-fargo-logo/WellsFargoLogo';
import KeyLine from './support/key-line/KeyLine';
import MenuButton from './support/menu-button/MenuButton';
import MenuBar from './support/menu-bar/MenuBar';
import SubLogo from './sub-logo/SubLogo';
import styles from './WFMasthead.less';
var WFMasthead = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? true : _ref$fixed,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      className = _ref.className,
      navigate = _ref.navigate,
      _ref$keyLine = _ref.keyLine,
      keyLine = _ref$keyLine === void 0 ? false : _ref$keyLine,
      keyLineClassName = _ref.keyLineClassName,
      _ref$includeSearch = _ref.includeSearch,
      includeSearch = _ref$includeSearch === void 0 ? false : _ref$includeSearch,
      NavigationMenu = _ref.navigationMenu;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var subLogoRef = useRef();
  var brand = useBrand();
  var device = useDevice();
  var suppressPrint = useSelector(function (_ref2) {
    var digitalCore = _ref2.digitalCore;
    return digitalCore.childWindows.suppressPagePrint;
  });
  var showKeyLine = brand !== 'tpb' && brand !== 'wfa' || keyLine;

  var _useWindowBounds = useWindowBounds(),
      screenWidth = _useWindowBounds.width;

  var classes = ['masthead', suppressPrint && 'noPrint', fixed && 'fixed', showKeyLine && 'showKeyLine'];
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    className: className,
    brand: brand,
    device: device
  });
  var gutterClassNames = getClasses({
    styles: styles,
    classes: ['gutter'],
    device: device
  });
  var context = {
    responsive: responsive,
    device: device,
    menuType: screenWidth > 767 ? 'bar' : 'button',
    navigate: navigate,
    menuOpen: menuOpen,
    setMenuOpen: setMenuOpen,
    subLogo: subLogoRef.current,
    showKeyLine: showKeyLine,
    includeSearch: includeSearch
  };
  return /*#__PURE__*/React.createElement(WFMastheadContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Block, {
    el: "nav",
    layout: true,
    vertical: true,
    className: classNames,
    elementRef: ref
  }, !device.isMobile && /*#__PURE__*/React.createElement(SkipLink, null), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    centered: true,
    flex: true
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    flex: true,
    center: true,
    className: styles.logoBar
  }, /*#__PURE__*/React.createElement(Guttered, {
    className: gutterClassNames
  }, 'dc' !== brand && /*#__PURE__*/React.createElement(Block, {
    inline: true,
    className: styles.logo
  }, /*#__PURE__*/React.createElement(WellsFargoLogo, null)), /*#__PURE__*/React.createElement(MenuButton, null), /*#__PURE__*/React.createElement(MenuBar, null), /*#__PURE__*/React.createElement(NavigationMenu, null)), showKeyLine && /*#__PURE__*/React.createElement(KeyLine, {
    className: keyLineClassName
  })), /*#__PURE__*/React.createElement(SubLogo, {
    gutterClassNames: gutterClassNames,
    ref: subLogoRef
  }))));
});
export default WFMasthead;